
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, ShoppingBag } from 'lucide-react';

interface EcommercePricesHeaderProps {
  onRefresh: () => void;
}

const EcommercePricesHeader: React.FC<EcommercePricesHeaderProps> = ({ onRefresh }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <ShoppingBag className="h-8 w-8 text-blue-600" />
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Ecommerce Prices</h1>
          <p className="text-gray-600">Track and manage ecommerce pricing data</p>
        </div>
      </div>
      <Button onClick={onRefresh} variant="outline" size="sm">
        <RefreshCw className="h-4 w-4 mr-2" />
        Refresh
      </Button>
    </div>
  );
};

export default EcommercePricesHeader;
